
import { defineComponent } from "vue";
import HeroBalanceCard from "@/components/dashboard/sequence/HeroBalanceCard.vue"; 
import StatTile from "@/components/dashboard/sequence/StatTile.vue";
import StatCard from "@/components/dashboard/sequence/StatCard.vue";
import { getDashboardData } from "@/api/dashboard";

export default defineComponent({
  name: "SequenceOverview",
  components: {
    HeroBalanceCard, 
    StatTile,
    StatCard,
  },
  props: {
    label: { type: String, default: "Lifetime Income" },
    currencySymbol: { type: String, default: "" },
    trend: { type: String, default: "15.8%" },
    totalBalance: { type: [Number, String], default: 0.0 },
    income: { type: [Number, String], default: 0.0 },
    expense: { type: [Number, String], default: 0.0 },
    businessAccount: { type: [Number, String], default: 0.0 },
    totalSaving: { type: [Number, String], default: 0.0 },
    reserve: { type: [Number, String], default: 0.0 }
  },
  data() {
    return {
      lifetimeIncome: null as number | string | null,
      lifetimeCurrency: "",
    };
  },
  computed: {
    displayAmount(): number | string {
      if (this.lifetimeIncome !== null && this.lifetimeIncome !== undefined && this.lifetimeIncome !== "") {
        return this.lifetimeIncome;
      }
      return this.totalBalance;
    },
    displayCurrency(): string {
      return this.lifetimeCurrency || this.currencySymbol;
    },
  },
  mounted() {
    this.loadLifetimeIncome();
  },
  methods: {
    async loadLifetimeIncome() {
      try {
        const response = await getDashboardData();
        const details = response?.data?.lifetimeincomedetails;
        if (details) {
          this.lifetimeIncome = details.income ?? details.INCOME ?? 0;
          this.lifetimeCurrency = details.curr ?? details.CURR ?? response?.data?.currency ?? "";
        } else if (response?.data?.currency) {
          this.lifetimeCurrency = response.data.currency;
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
});
